import React from 'react'
import './index.scss'
import DropdownForm from '@App/kit/fields/DropdownForm'
import { DropdownFormFieldProps } from '@App/forms/common/dropdown-form-field'

const CountryCode = (props: DropdownFormFieldProps) => (
    <div className="phone-country-code">
        <DropdownForm {...props} />
    </div>
)

export default CountryCode
